import React from 'react'
import classNames from 'classnames'
import { Trans } from '@mc/i18n'

interface TermsProps {
  /** The i18n key for translation */
  i18nKey?: string
  /** Additional CSS classes for the container */
  className?: string
  /** Custom namespace for i18n */
  namespace?: string
}

export const Terms: React.FC<TermsProps> = ({
  i18nKey = 'loginForm.terms',
  className,
  namespace = '@mc/authentication',
}) => {
  const containerClasses = classNames(
    'mc-text-x-small',
    'mc-text--center',
    'mc-opacity--muted',
    'mc-my-4',
    className,
  )

  // Determine if line break should be included based on the i18n key
  const shouldIncludeLineBreak = i18nKey === 'loginForm.terms'

  return (
    <p className={containerClasses}>
      <Trans i18nKey={i18nKey} ns={namespace}>
        {shouldIncludeLineBreak ? (
          <span className='mc-text--nowrap'>
            <br></br>
            {/* eslint-disable-next-line jsx-a11y/anchor-has-content */}
            <a className='mc-text--link mc-text--nowrap' href='/privacy' />
            {/* eslint-disable-next-line jsx-a11y/anchor-has-content */}
            <a className='mc-text--link mc-text--nowrap' href='/terms' />
          </span>
        ) : (
          <>
            {/* eslint-disable-next-line jsx-a11y/anchor-has-content */}
            <a className='mc-text--link mc-text--nowrap' href='/privacy' />
            {/* eslint-disable-next-line jsx-a11y/anchor-has-content */}
            <a className='mc-text--link mc-text--nowrap' href='/terms' />
          </>
        )}
      </Trans>
    </p>
  )
}
